import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styles from './index.less'
import * as sessions from '../reducers/session'

import { Tabs, Icon} from 'antd'

import Navigation from './Navigation'
import Download from './Download'
import News from './News'

import { contexts } from './background.config'


const TabPane = Tabs.TabPane;

@connect(({session, navigation})=>{
  return {
    session,
    navigation
  }
}, dispatch => bindActionCreators({...sessions}, dispatch))
export default class App extends Component{
  constructor(props){
    super(props);
    this.state = {
      showSkinPane: false,
      backgroundUrl: '',
      selectedTabKey: '1'
    }
  }


  componentWillUpdate(nextProps, nextState){
    if (!this.state.showSkinPane && nextState.showSkinPane){
      this.refs.skinPane.style.display = 'block'
    } else if (this.state.showSkinPane && !nextState.showSkinPane){
      this.refs.skinPane.style.animation = styles.moveOut + ' .5s';
      setTimeout(()=>{
        this.refs.skinPane.style = ''
      }, 500)
    }
  }

  exit(){
    this.props.exit()
  }

  changeBackground(){
    this.setState({
      showSkinPane: !this.state.showSkinPane
    })
  }

  handelChangeBackground(url){
    console.log(url);
    this.props.changeBackground({image_id: url});
    this.setState({
      backgroundUrl: url
    })
  }

  saveToDesktop(){
    alert("由于浏览器限制，请手动将下载的文件移放至桌面！");
    window.open("https://www.zt-express.com/static/url/内网门户.url")
  }



  render(){
    const { userinfo, background } = this.props.session;
    const { showSkinPane, backgroundUrl, selectedTabKey } = this.state;

    if (this.props.navigation.navigationList.length === 0){
      return ""
    }

    return (
      <div className={styles.mainContainer} style={{minHeight: window.innerHeight, backgroundImage: backgroundUrl? `url(${backgroundUrl})`: `url(${background})`}}>
        <div className={styles.header + ' clearfix'}>
          <div>
            <a onClick={()=>{}}>
              <Icon type={selectedTabKey === '1'?"profile": 'bars'} style={{lineHeight: '37px',fontSize: 26, float: 'left'}}/>
              <span style={{marginLeft: 5,fontSize: 16}}>{selectedTabKey === '1'?'导航':'导航'}</span>
            </a>
          </div>
          <a onClick={ ::this.exit }><Icon type="poweroff" style={{color: '#71cb78', fontWeight: 'bold', fontSize: 15, lineHeight: '37px'}} />  退出</a>
          <span><Icon type="user" style={{color: '#788bff', fontWeight: 'bold', fontSize: 15 }} />  亲爱的 {userinfo.nickname},欢迎您！</span>
          <span className={styles.change_skin_button}><a onClick={ ::this.changeBackground }>换肤</a></span>
          <span className={styles.change_skin_button}><a onClick={::this.saveToDesktop}>保存到桌面</a></span>
        </div>
        <div className={styles.logo}>
          <img src={require('../assets/logonew.png')}/>
        </div>
        <div className={styles.container}>
          <Tabs
            className={'main_tabs'}
            defaultActiveKey="1"
            {... (window.outerWidth <= 425? ({
              activeKey: selectedTabKey
            }):'')}
            tabPosition={"left"}
            type="line"
          >
            <TabPane key={1} tab={<div className={styles.tab_style}><Icon type="bars" style={{fontSize: 40}}/><span>导航</span></div>}>
              <Navigation />
            </TabPane>
            <TabPane key={2} tab={<div className={styles.tab_style}><Icon type="profile" style={{fontSize: 40}}/><span>新闻</span></div>}>
              <News />
            </TabPane>
            <TabPane key={3} tab={<div className={styles.tab_style}><Icon type="download" style={{fontSize: 40}}/><span>下载</span></div>}>
              <Download />
            </TabPane>
          </Tabs>
        </div>
        <div onClick={()=>{this.setState({showSkinPane: false})}} className={styles.over_body} style={{display: showSkinPane ?'block': 'none'}} />
        <div ref="skinPane" className={styles.skin_pane} >
          <Tabs
            defaultActiveKey="0"
            type="line"
            style={{width: 1020, margin: '0 auto'}}
            animated={false}
          >
            {
              contexts.map((data, ind)=>{
                const context = data.context;
                return (
                  <TabPane key={ind} tab={data.name} className="clearfix">
                    <div style={{ height: 220, position: 'relative'}}>
                      {
                        context.keys().map((item, index)=>{
                          let source = context(item);
                          let w = 108 + 2;
                          let h = 62.75 + 2;
                          let lImage = false;
                          let i = Math.floor(index/6);
                          let addLeft = i * 3*w;
                          let left = 0;
                          let top = 0;
                          if((index%6)>=3){
                            top = (index%6 - 3) * h;
                            left = 2*w + addLeft
                          }
                          if (i%2 === 0){
                            if((index%6)<3){
                              if ((index%6) === 0){
                                top = 0;
                                left = addLeft;
                                lImage = true
                              } else {
                                top = 2 * h;
                                left = addLeft + ((index%6)-1) * w
                              }
                            }
                          } else {
                            if((index%6)<3){
                              if ((index%6) === 2){
                                top = h;
                                left = addLeft;
                                lImage = true;
                              }else {
                                top = 0;
                                left = addLeft + (index%6) *w
                              }

                            }
                          }

                          return (
                            <span
                              key={index}
                              className={styles.skin_item}
                              onClick={this.handelChangeBackground.bind(this, source, ind, index)}
                              style={{
                                top: top,
                                left: left,
                              }}

                            >
                              <img src={source} style={{width: lImage ? 218 : 108, height: lImage ? 127.5 : 62.75}}/>
                            </span>
                          )
                        })
                      }
                    </div>
                  </TabPane>
                )
              })
            }
            {/*<TabPane key={1} tab="中通推荐" className="clearfix">
              <div style={{ height: 220, position: 'relative'}}>
                {
                  require.context('../assets/bg/zto', false).keys().map((item, index)=>{

                  })
                }
                {
                  imageDataList.map((item, index)=>{
                    let w = 108 + 2;
                    let h = 62.75 + 2;
                    let lImage = false;
                    let i = Math.floor(index/6);
                    let addLeft = i * 3*w;
                    let left = 0;
                    let top = 0;
                    if((index%6)>=3){
                      top = (index - 3) * h;
                      left = 2*w + addLeft
                    }
                    if (i%2 === 0){
                      if((index%6)<3){
                        if ((index%6) === 0){
                          top = 0;
                          left = addLeft;
                          lImage = true
                        } else {
                          top = 2 * h;
                          left = addLeft + ((index%6)-1) * w
                        }
                      }
                    } else {
                      if((index%6)<3){
                        if ((index%6) === 2){
                          top = h;
                          left = addLeft;
                          lImage = true;
                        }else {
                          top = 0;
                          left = addLeft + (index%6) *w
                        }

                      }
                    }

                    return (
                      <span
                        key={index}
                        className={styles.skin_item}
                        onClick={ this.handelChangeBackground.bind(this, item) }
                        style={{
                          top: top,
                          left: left
                        }}

                      >
                        <img src={item} style={{width: lImage ? 218 : 108, height: lImage ? 127.5 : 62.75}}/>
                      </span>
                    )
                  })
                }

              </div>
            </TabPane>
            <TabPane key={2} tab="明星">
              2
            </TabPane>
            <TabPane key={3} tab="风景">
              3
            </TabPane>
            <TabPane key={4} tab="炫彩">
              4
            </TabPane>
            <TabPane key={5} tab="小清新">
              5
            </TabPane>
            <TabPane key={6} tab="台湾特辑">
              6
            </TabPane>*/}

          </Tabs>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/App.js